import React from 'react';

const Steps = (props)=>{
	return (
		<div className="steps container-fluid">
			<div className="container p-0">
				<div className="row text-center">
					<div className="col-12 col-md-4 p-0">
						<div className="row">
							<div className="col-4 col-md-12">
								<div className="fa-section">
									<i className="fa fa-search" aria-hidden="true"></i>
								</div>
							</div>
							<div className="col-8 col-md-12">
								<p className="p-3 text-left text-md-center">
									Search for legal documents, forms and contracts.
								</p>
							</div>
						</div>
					</div>
					<div className="col-12 col-md-4 p-0">
						<div className="row">
							<div className="col-4 col-md-12">
								<div className="fa-section">
									<i className="fa fa fa-clock-o" aria-hidden="true"></i>
								</div>
							</div>
							<div className="col-8 col-md-12">
								<p className="p-3 text-left text-md-center">
									Answer a few questions and customize your legal document.
								</p>
							</div>
						</div>
					</div>
					<div className="col-12 col-md-4 p-0">
						<div className="row">
							<div className="col-4 col-md-12">
								<div className="fa-section">
									<i className="fa fa-file-text" aria-hidden="true"></i>
								</div>
							</div>
							<div className="col-8 col-md-12">
								<p className="p-3 text-left text-md-center">
									Download and print your customized legal document.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Steps;


// WEBPACK FOOTER //
// ./src/view/Steps.js